<!-- Sliding sidebar panel -->
<div class="sidebar-panel" [style.width.px]="width">
  <!-- Header -->
  <div class="sidebar-header" [class.sidebar-header--no-title]="!showTitle">
    <div class="sidebar-title" *ngIf="showTitle" [class.shimmer]="shimmerActive">
      <ion-icon name="custom-tailor-static" class="title-icon"></ion-icon>
      <span class="title-text">{{ sidebarTitle }}</span>
    </div>
    <div class="sidebar-header-actions">
      <button
        class="sidebar-action-btn danger"
        *ngIf="showCancel"
        (click)="cancelClick.emit()"
        title="Cancel"
      >
        <ion-icon name="stop-circle-outline"></ion-icon>
      </button>
      <button
        class="sidebar-action-btn"
        *ngIf="showNewChat"
        (click)="newChatClick.emit()"
        title="New chat"
      >
        <ion-icon name="create-outline"></ion-icon>
      </button>
      <button
        class="sidebar-close-btn"
        (click)="sidebarClose.emit()"
        title="Collapse"
      >
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>
  </div>

  <!-- Projected content (assistant panel, etc.) -->
  <div class="sidebar-body">
    <ng-content></ng-content>
  </div>
</div>
